import * as React from 'react';
import { PublicPageWrapper } from '../_pageWrappers/PublicPageWrapper';
import { PasswordResetPanel } from './_components/PasswordResetPanel';

export default function RequestPasswordResetPage (): JSX.Element
{
    return (
        <PublicPageWrapper>

            <PasswordResetPanel
                header="Gendan adgangskode"
                helpText="Indtast din e-mailadresse, så sender vi dig et link til at gendanne din adgangskode."
            />

        </PublicPageWrapper>
    );
}